/* claude-dewhite-page.js — 2026-08-25 (DRAFT THEME ONLY)
   The feature-icons gallery image (WATER-RESISTANT / BREATHABLE … black line
   art on white) gets its white ground removed on-page via canvas — the same
   deWhite technique the glass quick-view uses — so the CSS invert leaves
   white line art floating on the water. The stored image is never touched. */
(function () {
  function dewhite(img) {
    if (img.dataset.cdw) return;
    img.dataset.cdw = '1';
    var work = new Image();
    work.crossOrigin = 'anonymous';
    work.onload = function () {
      try {
        var c = document.createElement('canvas');
        c.width = work.naturalWidth; c.height = work.naturalHeight;
        var x = c.getContext('2d');
        x.drawImage(work, 0, 0);
        var d = x.getImageData(0, 0, c.width, c.height);
        var p = d.data;
        for (var i = 0; i < p.length; i += 4) {
          if (p[i] > 242 && p[i + 1] > 242 && p[i + 2] > 242) p[i + 3] = 0;
        }
        x.putImageData(d, 0, 0);
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = c.toDataURL('image/png');
      } catch (e) { /* tainted or failed — leave the original */ }
    };
    work.src = img.currentSrc || img.src;
  }
  function sweep() {
    Array.prototype.slice.call(document.querySelectorAll('img')).forEach(function (img) {
      var s = (img.currentSrc || img.src || '') + (img.getAttribute('srcset') || '');
      if (/featureicons|boonie_9048/i.test(s)) {   /* Boonie_<uuid>.png is the boonie's oddly-named icon sheet */
        if (img.complete && img.naturalWidth) dewhite(img);
        else img.addEventListener('load', function () { dewhite(img); }, { once: true });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sweep);
  else sweep();
  setTimeout(sweep, 1500);   /* lazy-loaded thumbs */
  setTimeout(sweep, 4000);
})();
